import { useEffect, useState } from "react";
import { resolveLibraryCoverUrl, isCachedLibraryCover } from "@/lib/libraryCovers";

/**
 * Resolve a library_items.cover_url value (which may be either an external
 * https URL or an internal `library-cover://…` reference) into a URL safe to
 * use in <img src>.
 */
export const useLibraryCoverUrl = (coverUrl: string | null | undefined): string | null => {
  const [resolved, setResolved] = useState<string | null>(
    coverUrl && !isCachedLibraryCover(coverUrl) ? coverUrl : null,
  );

  useEffect(() => {
    let cancelled = false;
    if (!coverUrl) {
      setResolved(null);
      return;
    }
    if (!isCachedLibraryCover(coverUrl)) {
      setResolved(coverUrl);
      return;
    }
    void resolveLibraryCoverUrl(coverUrl).then((url) => {
      if (!cancelled) setResolved(url);
    });
    return () => {
      cancelled = true;
    };
  }, [coverUrl]);

  return resolved;
};
